const isHex = value => {
	const re = /[0-9A-Fa-f]{6}/g;
	return re.test(value);
};

const getHexFromColorName = colorName => {
	const div = document.createElement("div");
	div.style.color = colorName;
	document.body.appendChild(div);
	const rgb = window.getComputedStyle(div).color;
	document.body.removeChild(div);
	const re = /rgb\((\d{1,3}), (\d{1,3}), (\d{1,3})\)/g;
	const match = re.exec(rgb);
	if (null === match) {
		return null;
	}
	return $.colpick.rgbToHex({
		r: parseInt(match[1]),
		g: parseInt(match[2]),
		b: parseInt(match[3]),
	}).toUpperCase();
};

const invertHex = hex => '#' + hex
	.match(/[a-f0-9]{2}/ig)
	.map(e => (255 - parseInt(e, 16) | 0).toString(16).replace(/^([a-f0-9])$/, '0$1'))
	.join('');

const setInputColor = (el, hex) => {
	el.style.removeProperty('background-color');
	!!hex && el.style.setProperty('background-color', hex, 'important');
	el.style.removeProperty('color');
	!!hex && el.style.setProperty('color', invertHex(hex), 'important');
};

$(document).ready(() => {
	$('[data-action=colorpicker]').each((_index, el) => {
		const $el = $(el);
		$el
			.css('text-transform', 'uppercase')
			.attr('autocomplete', 'off');
		setInputColor($el[0], $el.val());

		const onChange = (_hsb, hex, _rgb, el) => {
			const color = `#${hex}`;
			setInputColor(el, color);
			el.value = color;
		};

		$el.colpick({
			colorScheme: 'dark',
			layout: 'hex',
			submit: false,
			onBeforeShow: () => {
				let color = $el.val();
				if (!isHex(color)) {
					color = getHexFromColorName(color);
				}
				$el.colpickSetColor(color);
			},
			onSubmit: onChange,
			onChange,
		});

		$el.on('keyup', ev => {
			setInputColor(el, ev.target.value);
			el.value = ev.target.value;
			$(el).colpickHide();
		});
	});
});
